import { Text, View } from 'react-native'
import styled from 'styled-components'
import { ResponsiveImage } from '../../../elements/images/ResponsiveImage/ResponsiveImage'
import { Paragraph } from '../../../elements/typography'
import { media, useMediaIs } from '../../../style/media'
import { formatMarkdownItalics } from '../../../utils/strings'
import { FilmButtons } from '../FilmButtons/FilmButtons'

const SectionContent = styled(View)`
  height: 100%;
  justify-content: flex-end;
  padding: ${(props) =>
    `${props.theme.spacing.xxlarge}px ${props.theme.spacing.sm}px ${props.theme.spacing.md}px`};
`

const FilmContent = styled(View)`
  justify-content: flex-end;
  max-width: 310px;
  margin: 0 auto;
  height: 100%;
  ${media.sm`
    max-width: auto;
    width: 70%;
    margin: 0;
  `};
  ${media.md`
    margin-left: ${(props) => props.theme.spacing.large}px;
    width: 50%;
  `};
  ${media.lg`
    margin-left: ${(props) => props.theme.spacing.large}px;
    width: 520px;
  `};
`

const TitleLogo = styled(ResponsiveImage)`
  margin-bottom: ${(props) => props.theme.spacing.small}px;
`

const LaurelsImg = TitleLogo

const FilmParagraph = styled(Paragraph)`
  text-align: center;
  font-size: ${(props) => props.theme.fontSizes.xsmall}px;
  line-height: ${(props) => props.theme.fontSizes.xsmall * 1.3}px;
  ${media.sm`
    text-align: left;
    font-size: ${(props) => props.theme.fontSizes.large}px;
    line-height: ${(props) => props.theme.fontSizes.large * 1.3}px;
  `};
  ${media.lg`
    font-size: ${(props) => props.theme.fontSizes.medium}px;
    line-height: ${(props) => props.theme.fontSizes.medium * 1.3}px;
  `};
`

const Description = styled(FilmParagraph)`
  margin-bottom: ${(props) => props.theme.spacing.smedium}px;
`

const Quote = styled(FilmParagraph)`
  color: ${(props) => props.theme.colors.accent};
  font-style: italic;
`

const QuoteAuthor = styled(FilmParagraph)`
  color: ${(props) => props.theme.colors.accent};
  font-weight: ${(props) => props.theme.fontWeights.bold};
  margin-bottom: ${(props) => props.theme.spacing.medium}px;
`

const InvertedEm = styled(Text)`
  font-style: normal;
`

const formatItalics = formatMarkdownItalics((children, idx) => (
  <InvertedEm key={idx}>{children}</InvertedEm>
))

export const FilmBannerContent = ({ item, minHeight }) => {
  const sm = useMediaIs('sm')
  const { criticQuotes } = item
  return (
    <SectionContent style={{ minHeight }}>
      <FilmContent>
        <TitleLogo
          maxHeight={250}
          aspectRatio={2.1}
          transforms={{ crop: 'pad', gravity: sm ? 'south_west' : 'south' }}
          publicId={item.filmTitleImg}
          align={sm ? 'left' : ''}
        />
        {item.laurelImgs.map((cloudinaryId) => (
          <LaurelsImg
            key={cloudinaryId}
            maxHeight={70}
            aspectRatio={7.5}
            publicId={cloudinaryId}
            transforms={{ crop: 'pad', gravity: sm ? 'south_west' : 'south' }}
            align={sm ? 'left' : ''}
          />
        ))}
        <Description>{item.shortDescription}</Description>
        {Boolean(criticQuotes?.length && minHeight > 435) && (
          <>
            <Quote>{formatItalics(criticQuotes[0].quote)}</Quote>
            <QuoteAuthor>
              {formatItalics(criticQuotes[0].author)} - {formatItalics(criticQuotes[0].source)}
            </QuoteAuthor>
          </>
        )}
        <FilmButtons filmSlug={item.slug} justify={sm ? 'flex-start' : 'center'} />
      </FilmContent>
    </SectionContent>
  )
}
